import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class CommentDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"COMMENTAIRE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "",
            comment : event.detail?.comment,
            target : event.detail?.target,
          };

        // Supprime la propriété si elle existe dans l'objet
        if ('isAutomaticCommentary' in this) {
            delete this.isAutomaticCommentary;
        }
    }

    get comment() {
        return this.detail.comment;
    }

    set comment(value) {
        this.detail.comment = value;
    }

    get target() {
        return this.detail.target;
    }

    set target(value) {
        this.detail.target = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
    }
}